// extracted by mini-css-extract-plugin
export default {"SubscriptionCancelledContainer":"_SubscriptionCancelledContainer--TG6oY","Link":"_Link--uIada","BodyTitle":"_BodyTitle--QE0NZ"};